export const PROFILE_REQUEST = 'PROFILE_REQUEST';
export const PROFILE_SUCCESS = 'PROFILE_SUCCESS';
export const PROFILE_FAILURE = 'PROFILE_FAILURE';
export const RESET_VALIDATION_MESSAGE = 'RESET_VALIDATION_MESSAGE';